import { forwardRef, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { InputAdornment, TextField } from "@mui/material";
import { Button, Modal, Col, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { FormControlLabel } from "@mui/material";
import { Checkbox } from "@mui/material";
import _ from "lodash";
import ApiAccount from "../../../../core/api/api.account";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import SwalMessage from "../../_Components/SwalMessage";
import { PatternFormat } from "react-number-format";
import { tools } from "../../../../core/utils/tools";

const PatternFormatCustom = forwardRef(
  function PatternFormatCustom(props, inputRef) {
    const { onChange, ...other } = props;
    return (
      <PatternFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        format="#### - #### - #### - ####"
        mask=""
      />
    );
  }
);

export const NewSupplierAccountModal = ({
  showModalAccount,
  setShowModalAccount,
  selectedAccountId,
}) => {
  let handleClose = (e) => {
    setShowModalAccount(false);
  };
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
    getValues
  } = useForm({
    defaultValues: {
      id: selectedAccountId,
    },
  });

  useEffect(() => {
    (async () => {
      try {
        if (selectedAccountId) {
          var account = await ApiAccount.getAccountById(selectedAccountId);
          setValue("bank", account.data.bank);
          setValue("accountNumber", account.data.accountNumber);
          setValue("cardOwnerName", account.data.cardOwnerName);
          setValue("cardNumber", account.data.cardNumber);
          setValue("shebaNumber", account.data.shebaNumber);
          setValue("status", account.data.status);
        }
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, [selectedAccountId]);

  const onSubmit = async (data) => {
    try {
      data.accountOwnerName = data.cardOwnerName;
      data.cardNumber = data.cardNumber
        ?.split(" ")
        .join("")
        .split("-")
        .join("");
      if (_.size(data.cardNumber) < 16) {
        SwalMessage({
          title: "شماره کارت باید 16 رقم باشد",
          iSsuccess: false,
          timer: 5000,
        });
        return;
      }

      const response = selectedAccountId
        ? await ApiAccount.updateAccount(data)
        : await ApiAccount.createAccount(data);
      SwalMessage({
        title: response.message,
        iSsuccess: response.succeeded,
        timer: 5000,
      });
      if (response.succeeded == true) {
        document.getElementById("submitButton").click();
        handleClose();
      }
    } catch (error) {
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showModalAccount} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>درج اطلاعات حساب</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Controller
                name="bank"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    }}
                    label="نام بانک"
                    margin="normal"
                    variant="outlined"
                    className="form-control mb-2 "
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                    onKeyPress={(e) => {
                      if (e.target.value.length === 24) {
                        e.preventDefault();
                      }
                    }}
                  />
                )}
              />
              {errors.bank?.type === "required" && (
                <span className="text-danger text-right">
                  نام بانک نمیتواند خالی باشد
                </span>
              )}
            </Col>
            <Col xs="12">
              <Controller
                name="accountNumber"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="شماره حساب"
                    margin="normal"
                    variant="outlined"
                    className="form-control mb-2"
                    InputProps={{
                      maxLength: 24,
                    }}
                    size="small"
                    value={value || ""}
                    onChange={(e) => {
                      if (e.target.value && !tools.numberRegex.test(e.target.value)) {
                        e.target.value = getValues("accountNumber")
                        return
                      }
                      onChange(e)
                    }}
                    onKeyPress={(e) => {
                      if (e.target.value.length === 24) {
                        e.preventDefault();
                      }
                    }}
                  />
                )}
              />
              {errors.accountNumber?.type === "required" && (
                <span className="text-danger text-right">
                  شماره حساب نمیتواند خالی باشد
                </span>
              )}
            </Col>
            <Col xs="12">
              <Controller
                name="cardOwnerName"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="نام صاحب کارت"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    className="form-control mb-2 "
                    value={value || ""}
                    onChange={onChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    }}
                  />
                )}
              />
              {errors.cardOwnerName?.type === "required" && (
                <span className="text-danger text-right">
                  نام صاحب حساب نمیتواند خالی باشد
                </span>
              )}
            </Col>
            <Col xs="12">
              <Controller
                name="cardNumber"
                rules={{ required: true }}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <>
                    <TextField
                      // placeholder="شماره کارت"

                      value={value || ""}
                      onChange={onChange}
                      className=" mb-2 "
                      dir="ltr"
                      label="شماره کارت"
                      InputProps={{
                        inputComponent: PatternFormatCustom,
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "9px 14px",
                        },
                        width: "100%",
                        marginTop: "15px",
                      }}
                    />
                  </>
                )}
              />

              {errors.cardNumber?.type === "required" && (
                <span className="text-danger text-right">
                  شماره کارت نمیتواند خالی باشد
                </span>
              )}
              {/* {errors.cardNumber?.type === 'minLength' && <span>شماره کارت باید 16 رقم باشد</span>}  */}
            </Col>
            <div className="d-flex flex-column">
              <div className="d-flex">
                <Col xs="12">
                  <Controller
                    name="shebaNumber"
                    rules={{ required: true, maxLength: 24, minLength: 24 }}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        type="number"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              IR-
                            </InputAdornment>
                          ),
                        }}
                        label="شماره شبا"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                        className="form-control mb-2 ltr"
                        onKeyPress={(e) => {
                          if (e.target.value.length === 24) {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  />
                  {errors.shebaNumber?.type === "required" && (
                    <span className="text-danger text-right">
                      شماره شبا نمیتواند خالی باشد
                    </span>
                  )}
                  {(errors.shebaNumber?.type === "minLength" ||
                    errors.shebaNumber?.type === "maxLength") && (
                      <span className="text-danger text-right">
                        {" "}
                      شماره شبا باید 24 کاراکتر باشد
                      </span>
                    )}
                </Col>
                {/* <Form.Control
                    style={{ width: "25px" }}
                    disabled
                    className="form-control border-start-0 text-black bg-white mt-5 rounded-start-0 ps-0 pe-1 pl-0"
                    value="-IR"
                  /> */}
              </div>
            </div>

            <Col xs="12" className="text-end">
              <FormControlLabel
                control={
                  <Controller
                    name="status"
                    control={control}
                    render={({
                      field: { onChange, onBlur, value = false, name, ref },
                    }) => (
                      <Checkbox
                        onBlur={onBlur}
                        onChange={onChange}
                        checked={value}
                        inputRef={ref}
                        color="primary"
                      />
                    )}
                  />
                }
                label="فعال "
              />
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon /> ثبت شماره حساب
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
